//dependencias
import React, { Component } from 'react';

//componentes
import InventarioLogico from './inventarioLogico';
class Index extends Component {
    render() {
        return(
            <div className="Inicio">
                <InventarioLogico /> 
            </div>
        );
    }
}
export default Index;